<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="_mb-sm-50">携帯電話番号の登録変更</HeadingOne>

    <ErrorsAlert
      :errors="errors"
      :column-only="true"
      :items="inputItemsMb"
    />

    <WizardGroup class="_mb-sm-50 _mb-md-60">
      <MainWizard :active-index="1" type="phone"></MainWizard>
    </WizardGroup>

    <p>内容をご確認のうえ、よろしければ「変更する」を押してください。</p>
    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader> 電話番号（その他） </TableHeader>
              <TableData :has-error="errors['phone']">
                <InputGroup :errors="errors" :prop-names="['phone']">
                  <div>{{ userData.phone_mobile_1 }}-{{ userData.phone_mobile_2 }}-{{ userData.phone_mobile_3 }}</div>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitProfile">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitProfile"> 変更する </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb065"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  changePhoneNumberLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { inputItemsMb } from "@/constants/constant";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import InputGroup from "@/components/input/InputGroup";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import ErrorsAlert from "@/components/alert/ErrorsAlert";

export default {
  name: "Mb066",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
    BreadcrumbGroup,
    InputGroup,
    MainWizard,
    WizardGroup,
    ErrorsAlert,
  },
  setup() {
    setMeta({
      title: "電話番号登録変更",
      description: "",
      keywords: "",
    });

    return { inputItemsMb };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "携帯電話番号の登録変更",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      userData: {
        user_session: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
      },
    };
  },
  mounted() {
    this.setStoreData();
  },
  methods: {
    setStoreData() {
      this.userData.phone_mobile_1 = this.$store.state.changePhoneNumber.phone_mobile_1;
      this.userData.phone_mobile_2 = this.$store.state.changePhoneNumber.phone_mobile_2;
      this.userData.phone_mobile_3 = this.$store.state.changePhoneNumber.phone_mobile_3;
      if (window.$cookies.isKey('user_session')) {
        this.userData.user_session = window.$cookies.get('user_session');
      }
    },
    submitProfile: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            changePhoneNumberLambdaInvoke(this.userData)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$store.commit("setChangePhoneNumber", {});
                  this.$router.push({ name: "tem040" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.contact-box {
  > .card-body {
    justify-content: flex-start;
  }
}
</style>
